import { logger } from "cayo.ui";
import HttpStatus from "@cayo/shared/api/types/HttpStatus";
import { IQuery } from "@cayo/shared/components/GridContainer/types";
import { endpoints } from "@cayo/shared/services/endpoints.service";
import { IUserSettingsStore } from "./UserSettingsStore";
import { UserMeProfileClient } from "../../../api/user-me-profile.api";
import { getQuery, saveQuery } from "../../../utils/grid-utils";

const ELEMENT_CLASS = "gridColumns";

export class AdminUserSettingsStore implements IUserSettingsStore {
  private readonly _logger = logger.getLogger("AdminUserSettingsStore");
  private readonly _client: UserMeProfileClient;
  private readonly _name: string;

  private log(...msg: any[]) {
    this._logger.log(...msg);
  }

  constructor(private key: string) {
    this.log(".ctor -> key", key);
    this._name = key.replaceAll("/", "_");
    this._client = new UserMeProfileClient(endpoints.publicUrl);
  }

  public getQuery(): IQuery | undefined {
    const result = getQuery(this.key);
    this.log("getQuery -> key, result", this.key, result);
    return result;
  }

  public saveQuery(query: IQuery) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { effectiveFilter, alertRule, job, ...rest } = query;
    this.log("saveQuery -> key, query, save", this.key, query, rest);
    saveQuery(this.key, rest);
  }

  public async getColumns(): Promise<string[]> {
    try {
      const result = await this._client.getProfileElement(ELEMENT_CLASS, this._name);
      this.log("getColumns -> result", result);
      if (!result) {
        return [];
      }
      return JSON.parse(result.value);
    } catch (error: any) {
      if (error.status === HttpStatus.NOT_FOUND) {
        this._logger.debug("getColumns -> error", error);
      } else {
        this._logger.error("getColumns -> error", error);
      }
    }
    return [];
  }

  public async saveColumns(columns: string[]): Promise<void> {
    this.log("saveColumns -> columns", columns);
    await this._client.saveProfileElement(ELEMENT_CLASS, this._name, columns);
  }
}

export type IAdminUserSettingsStore = Pick<AdminUserSettingsStore, keyof AdminUserSettingsStore>;
